import http from "../../http";

const promotion = {
    selectByPage(r) {
        return http.get("/gateway/api/sycompany/pc/CompanyPromotionPc/selectByPage", r)
    },
    selectPromotionUserPage(r) {
        return http.get("/gateway/api/sycompany/pc/CompanyPromotionPc/selectPromotionUserPage", r)
    },
    selectById(r) {
        return http.get("/gateway/api/sycompany/pc/CompanyPromotionPc/selectById", r)
    },
    savePromotion(r) {
        return http.payload("/gateway/api/sycompany/pc/CompanyPromotionPc/savePromotion", r)
    },
    savePromotionUser(r) {
        return http.payload("/gateway/api/sycompany/pc/CompanyPromotionPc/savePromotionUser", r)
    },
    deleteByPromotionId(r) {
        return http.post("/gateway/api/sycompany/pc/CompanyPromotionPc/deleteByPromotionId", r)
    },
    deletePromotion(r) {
        return http.post("/gateway/api/sycompany/pc/CompanyPromotionPc/deletePromotion", r)
    },
    changeActive(r) {
        return http.post("/gateway/api/sycompany/pc/CompanyPromotionPc/changeActive", r)
    },
}
export default promotion
